"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@fluentui/react");
var react_2 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var react_i18next_1 = require("react-i18next");
var uniqueId_1 = require("../../helpers/uniqueId");
var ComboBoxItemPanel_1 = __importDefault(require("./ComboBoxItemPanel"));
var CustomComboBox_1 = __importDefault(require("./CustomComboBox"));
var CustomLabel_1 = require("../forms/CustomLabel");
var CustomTextField_1 = require("../forms/CustomTextField");
var SearchParameters_1 = require("./SearchParameters");
var Reducer_1 = require("./Reducer");
var forms_1 = require("../forms");
var boolean_1 = require("../../helpers/boolean");
require("./SearchComboBox.scss");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
exports.SearchComboBox = function (props) {
    var _a;
    var url = props.url, onChangeTextSearch = props.onChangeTextSearch, onSearch = props.onSearch, items = props.items, accessKeyProp = props.accessKeyProp, accessTextProp = props.accessTextProp, selectedItem = props.selectedItem, onSelectItem = props.onSelectItem, onRenderItem = props.onRenderItem, prefix = props.prefix, totalCount = props.totalCount, frequentlyUsed = props.frequentlyUsed, OneResultBehavior = props.OneResultBehavior, label = props.label, containerClassName = props.containerClassName, toolTip = props.toolTip, toolTipLink = props.toolTipLink, toolTipLinkOnClick = props.toolTipLinkOnClick, readOnly = props.readOnly, required = props.required, alignment = props.alignment, filters = props.filters, paginationSetting = props.paginationSetting, rtl = props.rtl, errorMessage = props.errorMessage, callOutWidth = props.callOutWidth, callOutClassName = props.callOutClassName, customNoRecordPanel = props.customNoRecordPanel, panelCustomLabelResource = props.panelCustomLabelResource, clearOnSelectedItem = props.clearOnSelectedItem, placeholder = props.placeholder;
    var _b = react_2.useState(false), hasFocus = _b[0], setHasFocus = _b[1];
    var _c = react_2.useReducer(Reducer_1.searchComboBoxReducer, {
        filters: filters,
        rtl: false,
        isSelected: false,
        filterVisible: false,
        hasCriterias: false
    }, function (c) { return c; }), state = _c[0], dispatch = _c[1];
    var _d = react_2.useState(frequentlyUsed ? 'FrequentlyUsed' : 'Search'), mode = _d[0], setMode = _d[1];
    var _e = react_2.useState(), isLoading = _e[0], setIsLoading = _e[1];
    var menuState = react_2.useRef();
    var t = react_i18next_1.useTranslation('SearchComboBox').t;
    var componentDomId = react_2.useRef("ComboBox_" + uniqueId_1.generateUniqueId());
    var searchComboBox = react_2.useRef("SearchComboBox_" + uniqueId_1.generateUniqueId());
    react_2.useEffect(function () {
        dispatch({ type: 'ChangeDirection', payload: { rtl: rtl !== null && rtl !== void 0 ? rtl : false } });
    }, [rtl]);
    react_2.useEffect(function () {
        dispatch({ type: 'pageSettingChanged', paginationSetting: paginationSetting });
    }, [paginationSetting]);
    react_2.useEffect(function () {
        dispatch({ type: 'DeclareFilter', payload: { filters: filters } });
    }, [filters]);
    react_2.useEffect(function () {
        setIsLoading(false);
        if ((items === null || items === void 0 ? void 0 : items.length) === 1 && onSelectItem && OneResultBehavior === 'select') {
            onSelectItem(items[0]);
        }
        if (items === undefined) {
            setMode('FrequentlyUsed');
        }
        dispatch({ type: 'receivedNewItems', payload: { items: items !== null && items !== void 0 ? items : [] } });
    }, [items]);
    react_2.useEffect(function () {
        if (errorMessage) {
            setIsLoading(false);
            dispatch({ type: 'receivedNewItems', payload: { items: [] } });
        }
    }, [errorMessage]);
    var openMenu = function () {
        var comboBoxElement = document.getElementById(componentDomId.current);
        var comboBoxCaretDownButton = comboBoxElement === null || comboBoxElement === void 0 ? void 0 : comboBoxElement.getElementsByClassName('ms-ComboBox-CaretDown-button');
        if (comboBoxCaretDownButton) {
            var element = comboBoxCaretDownButton.item(0);
            if (element) {
                menuState.current = true;
                element.click();
            }
        }
    };
    var performSearch = function (text, pageIndex) {
        setMode('Search');
        setIsLoading(true);
        var parameter = new SearchParameters_1.SearchParameter(filters !== null && filters !== void 0 ? filters : [], text, state.rtl);
        if (onSearch) {
            onSearch(parameter.primaryText, parameter.criterias, pageIndex);
        }
    };
    var onNavigate = react_2.useCallback(function (action) {
        var pageIndex = 0;
        switch (action.type) {
            case 'pageNav':
                pageIndex = action.pageNumber;
                break;
            case 'beginNav':
                pageIndex = 0;
                break;
            case 'endNav':
                pageIndex = (paginationSetting === null || paginationSetting === void 0 ? void 0 : paginationSetting.totalPage) ? (paginationSetting === null || paginationSetting === void 0 ? void 0 : paginationSetting.totalPage) - 1 : 0;
                break;
            default:
                break;
        }
        performSearch(state.searchText, pageIndex);
        dispatch(action);
    }, [state.searchText, paginationSetting === null || paginationSetting === void 0 ? void 0 : paginationSetting.totalPage]);
    var onRenderList = function (ComboBoxProps, defaultRender) {
        var _a, _b, _c, _d;
        if (defaultRender) {
            return (react_2.default.createElement(ComboBoxItemPanel_1.default, { isLoading: isLoading !== null && isLoading !== void 0 ? isLoading : false, mode: mode !== null && mode !== void 0 ? mode : 'Search', searchComboBoxState: state, paginationSetting: paginationSetting, searchText: (_a = state.searchText) !== null && _a !== void 0 ? _a : '', url: url, nbItems: mode === 'Search' ? ((_c = (_b = state.itemsView) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) : ((_d = frequentlyUsed === null || frequentlyUsed === void 0 ? void 0 : frequentlyUsed.length) !== null && _d !== void 0 ? _d : 0), totalItems: totalCount, onNavigate: onNavigate, errorMessage: errorMessage, customLabelResource: panelCustomLabelResource, showFrequentlyUsedLink: frequentlyUsed !== undefined && frequentlyUsed.length > 0, onShowFrequentlyUsedLink: function () { return setMode('FrequentlyUsed'); }, customNoRecordPanel: customNoRecordPanel, onchangeFilter: function () {
                    openMenu(); // to close it
                    dispatch({ type: 'FilterPanelToggle', payload: { visible: true } });
                } }, defaultRender(ComboBoxProps)));
        }
        return (null);
    };
    var onRenderOption = react_2.useCallback(function (ComboBoxProps, defaultRender) {
        var _a;
        if (onRenderItem) {
            return (react_2.default.createElement("div", { className: clsx_1.default('itemPanel', alignment === 'Left' ? 'leftSide' : 'rightSide', (selectedItem && (ComboBoxProps === null || ComboBoxProps === void 0 ? void 0 : ComboBoxProps.data) && accessKeyProp(selectedItem) === accessKeyProp(ComboBoxProps === null || ComboBoxProps === void 0 ? void 0 : ComboBoxProps.data)) ? 'selected' : '') }, (_a = onRenderItem(ComboBoxProps === null || ComboBoxProps === void 0 ? void 0 : ComboBoxProps.data)) !== null && _a !== void 0 ? _a : react_2.default.createElement(react_2.default.Fragment, null)));
        }
        if (defaultRender) {
            return (defaultRender(ComboBoxProps));
        }
        return (null);
    }, [selectedItem]);
    var itemToOptions = function (dataItems, getkey, getText) {
        if (dataItems) {
            var options = dataItems.map(function (di) {
                return ({
                    data: di,
                    key: getkey(di),
                    text: getText(di)
                });
            });
            return (options);
        }
        return ([]);
    };
    react_2.useEffect(function () {
        if (selectedItem) {
            dispatch({ type: 'Select', payload: { text: accessTextProp(selectedItem) } });
        }
        else {
            dispatch({ type: 'unSelect' });
        }
    }, [selectedItem]);
    var errMsg = state.filterVisible ? undefined : errorMessage;
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement("div", { id: searchComboBox.current, className: clsx_1.default('vertialFlexDiv', containerClassName) },
            label && (react_2.default.createElement(CustomLabel_1.Label, { required: required, toolTip: toolTip, toolTipLink: toolTipLink, toolTipLinkOnClick: toolTipLinkOnClick }, label)),
            react_2.default.createElement("div", { className: clsx_1.default('searchComboBox', hasFocus ? 'hasFocus' : '', (errMsg !== null && errMsg !== void 0 ? errMsg : '') !== '' ? 'hasError' : '') },
                prefix && (react_2.default.createElement("div", { className: clsx_1.default('searchComboBoxPrefix', hasFocus ? 'hasFocus' : '', (errMsg !== null && errMsg !== void 0 ? errMsg : '') !== '' ? 'hasError' : '') },
                    react_2.default.createElement("span", null, prefix))),
                react_2.default.createElement(CustomComboBox_1.default, { disabled: readOnly, placeholder: placeholder, id: componentDomId.current, className: clsx_1.default(prefix ? 'hasPrefix' : '', (errMsg !== null && errMsg !== void 0 ? errMsg : '') !== '' ? 'hasError' : ''), calloutProps: { className: clsx_1.default('applyContentMinWidthFitSearchComboBox', callOutClassName !== null && callOutClassName !== void 0 ? callOutClassName : '', callOutWidth === 'Fixed' ? 'applyContentFitSearchComboBox' : '') }, label: label, toolTip: toolTip, toolTipLink: toolTipLink, toolTipLinkOnClick: toolTipLinkOnClick, containerClassName: clsx_1.default(containerClassName), onRenderList: onRenderList, onRenderOption: onRenderOption, onRenderContainer: function (p, df) {
                        var dd = document.getElementById(searchComboBox.current);
                        document.body.style.setProperty('--currentSearchComboBoxMinSize', (dd === null || dd === void 0 ? void 0 : dd.clientWidth.toString()) + "px");
                        if (df) {
                            return (df(p));
                        }
                        return (null);
                    }, onFocus: function () {
                        setHasFocus(true);
                        if (menuState.current !== true && state.filterVisible === false) {
                            openMenu();
                        }
                    }, onBlur: function () { return setHasFocus(false); }, onMenuDismissed: function () {
                        menuState.current = false;
                    }, options: itemToOptions(mode === 'Search' ? state.itemsView : frequentlyUsed, accessKeyProp, accessTextProp), allowFreeform: true, text: state.searchText, selectedKey: selectedItem ? accessKeyProp(selectedItem) : undefined, onKeyUp: function (ev) {
                        var txt = ev.nativeEvent.target.defaultValue;
                        if (selectedItem) {
                            if (txt !== state.searchText) {
                                if (onSelectItem) {
                                    onSelectItem(undefined);
                                }
                                dispatch({ type: 'unSelect' });
                            }
                        }
                        else {
                            dispatch({ type: 'ChangeSearch', payload: { searchText: txt } });
                        }
                    }, onChange: function (_, option, index, value) {
                        var _a, _b;
                        if (onSelectItem) {
                            onSelectItem(option === null || option === void 0 ? void 0 : option.data);
                        }
                        if (option && value === undefined) {
                            if (clearOnSelectedItem) {
                                dispatch({ type: 'Clear' });
                                return;
                            }
                            var val = option.text;
                            if (onChangeTextSearch) {
                                val = onChangeTextSearch(option.text);
                            }
                            dispatch({ type: 'Select', payload: { text: val } });
                        }
                        else {
                            var val = value !== null && value !== void 0 ? value : '';
                            if (onChangeTextSearch) {
                                val = onChangeTextSearch(val);
                            }
                            performSearch(val, (_b = (_a = state.pageInfo) === null || _a === void 0 ? void 0 : _a.currentPage) !== null && _b !== void 0 ? _b : 0);
                            dispatch({ type: 'ChangeSearch', payload: { searchText: val } });
                            openMenu();
                        }
                    } }),
                ((state.searchText ? state.searchText.trim() : '') !== '') && (react_2.default.createElement(react_1.Icon, { className: clsx_1.default('clearButton', hasFocus ? 'hasFocus' : '', (errMsg !== null && errMsg !== void 0 ? errMsg : '') !== '' ? 'hasError' : ''), iconName: 'Cancel', onClick: function () {
                        if (selectedItem) {
                            if (onSelectItem) {
                                onSelectItem(undefined);
                            }
                        }
                        else {
                            dispatch({ type: 'Clear' });
                            setMode(frequentlyUsed ? 'FrequentlyUsed' : 'Search');
                        }
                    } })),
                (filters && filters.length > 0 && state.isSelected === false) && (react_2.default.createElement(react_1.Icon, { className: clsx_1.default('filterButton', hasFocus ? 'hasFocus' : '', (errMsg !== null && errMsg !== void 0 ? errMsg : '') !== '' ? 'hasError' : ''), iconName: state.hasCriterias ? 'FilterSolid' : 'Filter', onClick: function () {
                        var dd = document.getElementById(searchComboBox.current);
                        document.body.style.setProperty('--currentSearchComboBoxMinSize', (dd === null || dd === void 0 ? void 0 : dd.clientWidth.toString()) + "px");
                        if (state.filterVisible) {
                            dispatch({ type: 'FilterPanelToggle', payload: { visible: false } });
                        }
                        else {
                            dispatch({ type: 'FilterPanelToggle', payload: { visible: true } });
                        }
                    } })),
                selectedItem ? (react_2.default.createElement(react_1.Icon, { iconName: 'CompletedSolid', className: clsx_1.default('itemSelected', hasFocus ? 'hasFocus' : '') })) : (react_2.default.createElement(react_1.PrimaryButton, { disabled: readOnly, className: 'searchComboBox-searchButton', iconProps: { iconName: 'Search' }, onClick: function () {
                        var _a, _b;
                        performSearch(state.searchText, (_b = (_a = state.pageInfo) === null || _a === void 0 ? void 0 : _a.currentPage) !== null && _b !== void 0 ? _b : 0);
                        dispatch({ type: 'FilterPanelToggle', payload: { visible: false } });
                        openMenu();
                    } }))),
            react_2.default.createElement("span", { className: 'SearchComboBoxErrorMessage' }, errMsg !== null && errMsg !== void 0 ? errMsg : '')),
        state.filterVisible &&
            (react_2.default.createElement(react_1.Callout, { target: "#" + searchComboBox.current, isBeakVisible: false, className: clsx_1.default('applyContentMinWidthFitSearchComboBox', callOutClassName !== null && callOutClassName !== void 0 ? callOutClassName : '', callOutWidth === 'Fixed' ? 'applyContentFitSearchComboBox' : '') },
                react_2.default.createElement("div", { className: 'filterComboBoxPanel' },
                    react_2.default.createElement("div", { className: 'filterComboBoxGrid' }, (_a = state.editCriterias) === null || _a === void 0 ? void 0 : _a.map(function (criteria) {
                        var _a, _b, _c, _d, _e;
                        return (react_2.default.createElement(react_2.Fragment, { key: "criteria_" + criteria.name },
                            react_2.default.createElement(CustomLabel_1.Label, null, criteria.name),
                            criteria.definition.type === 'text' && (react_2.default.createElement(CustomTextField_1.TextField, { errorMessage: criteria.definition.errorMessage, prefix: criteria.definition.prefix, value: criteria.value, onChange: function (_, val) {
                                    dispatch({ type: 'UpdateCriteria', payload: { name: criteria.name, value: val } });
                                } })),
                            criteria.definition.type === 'date' && (react_2.default.createElement(forms_1.DatePicker, { value: ((_a = criteria.value) !== null && _a !== void 0 ? _a : '') !== '' ? new Date(Date.parse((_b = criteria.value) !== null && _b !== void 0 ? _b : '')) : undefined, onSelectDate: function (d) {
                                    dispatch({ type: 'UpdateCriteria', payload: { name: criteria.name, value: d ? d.toDateString() : '' } });
                                } })),
                            criteria.definition.type === 'boolean' && (react_2.default.createElement(forms_1.Toggle, { checked: boolean_1.parseBoolean((_c = criteria.value) !== null && _c !== void 0 ? _c : criteria.definition.defaultValue), onChange: function (_, checked) {
                                    dispatch({ type: 'UpdateCriteria', payload: { name: criteria.name, value: boolean_1.booleanAsString(checked, rtl !== null && rtl !== void 0 ? rtl : false) } });
                                } })),
                            criteria.definition.type === 'list' && (react_2.default.createElement(forms_1.Dropdown, { errorMessage: criteria.definition.errorMessage, selectedKey: criteria.value, options: (_d = criteria.definition.options) !== null && _d !== void 0 ? _d : [], onChange: function (_, val) {
                                    dispatch({ type: 'UpdateCriteria', payload: { name: criteria.name, value: (val === null || val === void 0 ? void 0 : val.key) ? val === null || val === void 0 ? void 0 : val.key.toString() : undefined } });
                                } })),
                            criteria.definition.type === 'label' && (react_2.default.createElement(CustomLabel_1.Label, null, (_e = criteria.value) !== null && _e !== void 0 ? _e : criteria.definition.defaultValue))));
                    })),
                    react_2.default.createElement("div", { className: 'filterComboBoxActions' },
                        react_2.default.createElement(react_1.DefaultButton, { text: t('Cancel'), onClick: function () {
                                dispatch({ type: 'CancelCriterias' });
                            } }),
                        react_2.default.createElement(react_1.PrimaryButton, { iconProps: { iconName: 'FilterSolid' }, text: t('Apply'), onClick: function () {
                                dispatch({ type: 'ApplyCriterias' });
                            } })))))));
};
//# sourceMappingURL=SearchComboBox.js.map